import React from 'react'
import { Link } from 'react-router-dom'

export default function IntegrationPartner({ data }) {

  return (
    <section className="integration-partner" style={{ backgroundImage: `url(${data?.bgImage})`  }}>
      <div className="container">
        <div className="row">
          <div className="row align-items-center">
            <div className="col-sm-12 col-md-10 col-lg-6">
              <div className="integration-content">
                <span className="sub">{data?.subTitle} </span>
                <h2 className="heading"  dangerouslySetInnerHTML={{ __html: data?.heading }}/>
                <p> {data?.description} </p>
                <div className="smart-btn">
                  <Link className="theme-btn white-btn"   to={data?.buttonLink}   >
                    <span>{data?.buttonText}</span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-5 col-lg-6"></div>
          </div>
        </div>
      </div>
    </section>
  )
}